import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchClients = createAsyncThunk("clients/fetch", async (params = {}) => {
  const response = await api.get("/agents/clients", { params });
  return response.data;
});

const clientsSlice = createSlice({
  name: "clients",
  initialState: {
    list: [],
    totalClients: 0,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => { state.status = "loading"; })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload.clients;
        state.totalClients = action.payload.totalClients;
      });
  },
});

export default clientsSlice.reducer;
